"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.4 5.873v8.312c.581-.179 1.393-.335 2.45-.335s1.869.156 2.45.335V5.873a4 4 0 0 0-.288-.11c-.446-.15-1.157-.313-2.162-.313s-1.716.162-2.162.313a4 4 0 0 0-.288.11m6.3 0v8.312c.581-.179 1.393-.335 2.45-.335s1.869.156 2.45.335V5.873a4 4 0 0 0-.288-.11c-.446-.15-1.157-.313-2.162-.313s-1.716.162-2.162.313a4 4 0 0 0-.288.11m5.6-.423.405-.57a.7.7 0 0 1 .295.57v9.8a.7.7 0 0 1-1.113.567q-.026-.017-.098-.055a3.4 3.4 0 0 0-.477-.199c-.446-.15-1.157-.313-2.162-.313s-1.716.162-2.162.313a3.4 3.4 0 0 0-.477.199 2 2 0 0 0-.113.064.7.7 0 0 1-.81-.01q-.026-.017-.099-.054a3.4 3.4 0 0 0-.477-.199c-.446-.15-1.157-.313-2.162-.313s-1.716.162-2.162.313a3.4 3.4 0 0 0-.477.199 2 2 0 0 0-.113.064A.7.7 0 0 1 3 15.25v-9.8a.7.7 0 0 1 .295-.57l.405.57-.405-.57.001-.002h.001l.003-.003.007-.004.074-.048q.067-.042.184-.104c.157-.08.38-.183.674-.282.59-.2 1.452-.387 2.611-.387s2.022.188 2.61.387c.219.074.398.149.54.216.142-.067.322-.142.54-.216.588-.2 1.451-.387 2.61-.387s2.022.188 2.61.387c.294.1.518.201.675.282a3 3 0 0 1 .258.152l.007.004.003.002.002.002zm-.405 10.37v.002z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=OpenBookIcon20.js.map